// POSTHOG_CLIENT: PostHog analytics for Reno Quoting App
import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_YirJmFCjqvK8kYAU77yuVTJJN30dpXGPaolb1F17qVB';
const POSTHOG_HOST = 'https://us.posthog.com';

let initialized = false;

export function initPosthog(): void {
	if (initialized) return;
	initialized = true;

	posthog.init(POSTHOG_KEY, {
		api_host: POSTHOG_HOST,
		capture_pageview: false, // We handle SPA pageviews manually
		capture_pageleave: true,
		autocapture: true,
		capture_exceptions: true, // Auto-capture JS errors as $exception events
		session_recording: { maskAllInputs: true }
	});
}

export function identifyUser(userId: string, properties?: Record<string, unknown>): void {
	posthog.identify(userId, properties);
}

export function trackEvent(event: string, properties?: Record<string, unknown>): void {
	posthog.capture(event, properties);
}

export function trackPageview(): void {
	posthog.capture('$pageview');
}

export function resetPosthog(): void {
	posthog.reset();
}

export { posthog };
